import Ring from '../../../assets/img/anillo.png';
// eslint-disable-next-line no-unused-vars
import styles from './style.module.scss';

const PlanEvent = () => (
    <section className={`${styles.container} container`}>
        <article className={styles['text-container']}>
            <span className={styles.title}>Planifica tu evento sin estrés</span>
            <figure className={`${styles['image-container']} ${styles['image-mobile']}`}>
                <img src={Ring} alt='anillo' className={styles.image} />
            </figure>
            <span className={styles.description}>Crea tu lista de invitados y déjanos ocuparnos del envío de invitaciones y la gestión de confirmaciones de manera fácil y eficiente.</span>
        </article>
        <figure className={`${styles['image-container']} ${styles['image-desktop']}`}>
            <img src={Ring} alt='anillo' className={styles.image} />
        </figure>
    </section>
);

export default PlanEvent;
